import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const dynamicRewardsRootActionPath = 'core/DynamicRewardsPageContent/GET';

export const DYNAMIC_REWARDS_CONTENT_GET_SUCCESS = `${dynamicRewardsRootActionPath}_${SUCCESS_SUFFIX}`;
export const DYNAMIC_REWARDS_CONTENT_GET_FAILURE = `${dynamicRewardsRootActionPath}_${FAILURE_SUFFIX}`;
